import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "activity-list"
}
const _hoisted_2 = {
  key: 0,
  class: "activity-img"
}
const _hoisted_3 = {
  key: 1,
  class: "activity-img"
}
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.activity)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.activity.activity_by && _ctx.activity.activity_by.image)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("img", {
                src: _ctx.activity.activity_by.image,
                alt: _ctx.activity.activity_by.full_name,
                title: _ctx.activity.activity_by.email
              }, null, 8, ["src", "alt", "title"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("img", {
                src: 
        _ctx.data.imageBaseUrl
          ? `${_ctx.data.imageBaseUrl}img/no-user.jpg`
          : 'img/no-user.jpg'
      ,
                alt: ""
              }, null, 8, ["src"])
            ])),
        (_ctx.activity.description)
          ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.activity.description) + " " + _toDisplayString(_ctx.localTimestamp), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}